export default __webpack_public_path__ + "static/media/Coral 9781408304778.03da0e6c.jpg";